import React from "react";

const Sidebar = ({ activeTab, onTabChange }) => {
  return (
    <div className="perfil-content">
      <ul>
        <li className={activeTab === "meus-dados" ? "active" : ""} onClick={() => onTabChange("meus-dados")}>
          Meus Dados
        </li>
        <li className={activeTab === "meus-pedidos" ? "active" : ""} onClick={() => onTabChange("meus-pedidos")}>
          Meus Pedidos
        </li>
        <li className={activeTab === "meus-livros" ? "active" : ""} onClick={() => onTabChange("meus-livros")}>
          Meus Livros
        </li>
        <li className={activeTab === "insignecoins" ? "active" : ""} onClick={() => onTabChange("insignecoins")}>
          Insigne Coins
        </li>
        
      </ul>
    </div>
  );
};

export default Sidebar;
